var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value.length > 0)?_c('div',[(!_vm.show)?_c('img',{staticStyle:{"margin-right":"18px"},attrs:{"src":require('@/assets/images/svg/ícone-não-valido.svg'),"alt":""}}):_c('img',{staticStyle:{"margin-right":"18px"},attrs:{"src":require('@/assets/images/svg/ícone-valido.svg'),"alt":""}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }